// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2sQYF","notes":"Notes_notes__3Lxxf"};